import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { DateTime } from 'luxon';

import withStyles from '@mui/styles/withStyles';

import footerStyle from '../md/assets/jss/material-dashboard-pro-react/components/footerStyle';

function Footer({ ...props }) {
  const { classes, fluid, white, rtlActive } = props;
  const container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white,
  });
  const anchor =
    classes.a +
    cx({
      [' ' + classes.whiteColor]: white,
    });
  return (
    <footer className={classes.footer}>
      <div className={container}>
        <p className={classes.right}>
          &copy; {DateTime.local().year}{' '}
          <a href="https://www.allevasoft.com" className={anchor}>
            Alleva
          </a>
          {rtlActive ? ', مصنوعة مع الحب لشبكة الإنترنت أفضل' : ' -- All Rights Reserved'}
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool,
};

export default withStyles(footerStyle)(Footer);
